import { Message } from 'components/alert/Message';

const Hooks = () => {
  return {
    mutationProps: (resetForm, props) => {
      const { onSuccess, isSuccess = true, errorHeading = '', error, onError } = props || {};
      return {
        onSuccess: (res) => {
          if (onSuccess) {
            onSuccess(res);
          }
          if (isSuccess) Message.success(`${res.status}`, 'Success');
          if (resetForm) resetForm();
        },
        onError: (err) => {
          if (onError) {
            onError();
          }
          Message.error(`${err.response.data.error || err.response.data.status}`, error ? 'Error' : errorHeading);
        },
      };
    },
  };
};

export const CustomHook = Hooks;
